import { ISODateString } from "@m7-health/shared-utils";

export enum EHierarchyModelViewType {
  healthSystem = "Health System",
  region = "Region",
  market = "Market",
  facility = "Facility",
  unit = "Unit",
}

/**
 * Container of HierarchyModelBase with a next link to children view.
 */
export type HierarchyModelView = {
  type: EHierarchyModelViewType;
  name: string;
  model: HierarchyModelBase;
  next?: HierarchyModelView;
  hasNext?: boolean;
  selectedId?: string | null;
  parentOptions?: HierarchyModelBase[];
};

/**
 * Union of children types.
 */
export type HierarchyModelBase = {
  id: string | null;
  name: string;
  archivedAt?: ISODateString | null;
  children?: HierarchyModelBase[];
  healthSystemId?: string | null;
  regions?: HierarchyModelBase[];
  regionId?: string | null;
  markets?: HierarchyModelBase[];
  marketId?: string | null;
  facilities?: HierarchyModelBase[];
  facilityId?: string | null;
  units?: HierarchyModelBase[];
  scheduleDurationInWeeks?: number | null;
  timezone?: string | null;
};
